import { useState, useCallback } from 'react'

interface ConfirmState {
  open: boolean
  title: string
  message: string
  onConfirm: () => Promise<void>
}

const DEFAULT_STATE: ConfirmState = {
  open: false,
  title: '',
  message: '',
  onConfirm: () => Promise.resolve(),
}

export function useConfirm() {
  const [state, setState] = useState<ConfirmState>(DEFAULT_STATE)
  const [loading, setLoading] = useState(false)

  const confirm = useCallback(
    (title: string, message: string, onConfirm: () => Promise<void> | void) => {
      setState({
        open: true,
        title,
        message,
        onConfirm: async () => {
          setLoading(true)
          try {
            await onConfirm()
          } finally {
            setLoading(false)
            setState(DEFAULT_STATE)
          }
        },
      })
    },
    []
  )

  const cancel = useCallback(() => {
    if (loading) return
    setState(DEFAULT_STATE)
  }, [loading])

  return { state, loading, confirm, cancel }
}
